(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-quiz-magnesio"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initQuiz = (root) => {
      if (!root || root.dataset.quizInitialized === 'true') return;
      root.dataset.quizInitialized = 'true';

      const intro = root.querySelector('[data-quiz-intro]');
      const panel = root.querySelector('[data-quiz-panel]');
      const results = root.querySelector('[data-quiz-results]');
      const startButton = root.querySelector('[data-quiz-start]');
      const backButton = root.querySelector('[data-quiz-back]');
      const restartButton = root.querySelector('[data-quiz-restart]');
      const progressText = root.querySelector('[data-progress-text]');
      const progressPercent = root.querySelector('[data-progress-percent]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const resultGrid = root.querySelector('[data-result-grid]');
      const primaryResult = root.querySelector('[data-primary-result]');
      const alternativeSection = root.querySelector('[data-alternative-section]');
      const alternativeResult = root.querySelector('[data-alternative-result]');
      const volumeOffer = root.querySelector('[data-volume-offer]');
      const resultSummary = root.querySelector('[data-result-summary]');
      const questions = Array.from(root.querySelectorAll('[data-question]'));
      const sourceCards = Array.from(root.querySelectorAll('[data-quiz-product]'));

      const QUIZ_VERSION = 'magnesium_v28';
      const QUIZ_SOURCE = 'magnesium_quiz';
      const DEBUG = false;

      const answers = {};
      let currentQuestion = 'goal';
      let currentQuizId = null;
      let startedTracked = false;
      let completedTracked = false;
      let resultViewedTracked = false;
      let currentResultContext = null;

      const pushEvent = (eventName, extra = {}) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, quiz_name: 'magnesium_selector', ...extra });
      };

      const generateQuizId = () => {
        try {
          if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return `mag_${window.crypto.randomUUID().replace(/-/g, '')}`;
          }

          if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
            const bytes = new Uint8Array(12);
            window.crypto.getRandomValues(bytes);
            return `mag_${Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')}`;
          }
        } catch (error) {
          // El ID de respaldo sigue siendo anónimo; analytics nunca debe romper el quiz.
        }

        return `mag_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
      };

      const beginNewQuizRun = () => {
        currentQuizId = generateQuizId();
        startedTracked = false;
        completedTracked = false;
        resultViewedTracked = false;
        currentResultContext = null;
      };

      // Capa única de PostHog. No identifica personas, no persiste respuestas en perfiles
      // y falla silenciosamente cuando analytics no está disponible.
      const trackQuizEvent = (eventName, properties = {}) => {
        try {
          if (
            window.posthog &&
            typeof window.posthog.capture === 'function'
          ) {
            window.posthog.capture(eventName, {
              quiz_id: currentQuizId,
              quiz_version: QUIZ_VERSION,
              ...properties
            });
            return true;
          }
        } catch (error) {
          // PostHog nunca debe afectar al flujo del quiz.
        }
        return false;
      };

      const debugQuiz = (message, payload = {}) => {
        if (!DEBUG) return;
        try {
          console.debug(`[Quiz Magnesio] ${message}`, payload);
        } catch (error) {
        }
      };

      const trackStartedOnce = () => {
        if (startedTracked) return;
        if (!currentQuizId) beginNewQuizRun();
        if (trackQuizEvent('magnesium_quiz_started')) startedTracked = true;
      };

      const ANALYTICS_QUESTION_KEYS = Object.freeze({
        goal: 'main_goal',
        priority: 'formula_preference',
        format: 'preferred_format',
        purchase: 'final_priority'
      });

      const ANALYTICS_ANSWER_KEYS = Object.freeze({
        goal: Object.freeze({
          muscle: 'muscle_recovery',
          cramps: 'muscle_cramps',
          energy: 'energy_fatigue',
          relax: 'relaxation',
          focus: 'focus_cognition',
          laxative: 'laxative_constipation',
          general: 'general'
        }),
        priority: Object.freeze({
          simple: 'single_form',
          multi: 'multi_form',
          cofactors: 'cofactors',
          unsure: 'no_preference'
        }),
        format: Object.freeze({
          solid: 'solid',
          powder: 'powder',
          gummy: 'gummy',
          any: 'no_preference'
        }),
        purchase: Object.freeze({
          tolerance: 'digestive_tolerance',
          economy: 'lowest_price',
          value: 'value',
          best_fit: 'best_fit',
          any: 'no_preference'
        })
      });

      const analyticsAnswerKey = (questionKey, rawValue) => {
        if (!rawValue) return null;
        return ANALYTICS_ANSWER_KEYS[questionKey]?.[rawValue] || rawValue;
      };

      const selectedAnswerLabel = (questionKey) => {
        const button = getQuestion(questionKey)?.querySelector('.mq-option.is-selected');
        return button?.querySelector('span:last-child')?.textContent?.trim() || null;
      };

      const roundScore = (value) => {
        const numeric = Number(value);
        return Number.isFinite(numeric) ? Math.round(numeric * 100) / 100 : null;
      };

      const flow = () => ['goal', 'priority', 'format', 'purchase'];

      const getQuestion = (key) => root.querySelector(`[data-question="${key}"]`);

      const updateProgress = () => {
        const sequence = flow();
        const index = Math.max(0, sequence.indexOf(currentQuestion));
        const total = sequence.length;
        const step = index + 1;
        const percent = Math.round((step / total) * 100);

        progressText.textContent = `${root.dataset.i18nProgressQuestion} ${step} ${root.dataset.i18nProgressOf} ${total}`;
        progressPercent.textContent = `${percent}%`;
        progressBar.style.width = `${percent}%`;
        backButton.disabled = index === 0;
      };

      const showQuestion = (key, focus = true) => {
        currentQuestion = key;
        questions.forEach((question) => {
          question.hidden = question.dataset.question !== key;
        });
        updateProgress();

        if (focus) {
          const title = getQuestion(key)?.querySelector('.mq-question__title');
          window.setTimeout(() => title?.focus({ preventScroll: true }), 30);
        }
      };

      const showPanel = () => {
        intro.hidden = true;
        results.hidden = true;
        panel.hidden = false;
      };

      const resetSelections = () => {
        questions.forEach((question) => {
          question.querySelectorAll('.mq-option').forEach((button) => {
            button.classList.remove('is-selected');
            button.setAttribute('aria-pressed', 'false');
          });
        });
      };

      const SCORING = Object.freeze({
        // Jerarquía principal: objetivo > fórmula/tolerancia > formato > precio.
        goalMultiplier: 8,          // afinidad 0..5 => 0..40
        formulaMatch: 13,
        formulaMismatch: -2,
        formatMatch: 10,
        formatMismatch: -5,
        toleranceMultiplier: 2.5,
        toleranceMin: -6,
        toleranceMax: 8,
        economyCoreBand: 12,
        economyMaxAdjustment: 10,
        valueCoreBand: 15,
        valueMaxAdjustment: 5,
        tradeoff: Object.freeze({
          toleranceGap: 2.5,
          toleranceCoreWindow: 10,
          priceCoreWindow: 12,
          priceRelativeGap: 0.15
        })
      });

      const tokens = (value = '') => value.split(',').map((item) => item.trim()).filter(Boolean);


      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const parseAffinity = (value = '') => {
        const output = {};
        value.split(',').forEach((entry) => {
          const [key, raw] = entry.split(':');
          if (!key) return;
          const number = Number(raw);
          output[key.trim()] = Number.isFinite(number) ? number : 0;
        });
        return output;
      };

      const productAttributes = (card) => {
        const price = Number(card.dataset.price || 0);
        const doseMin = Number(card.dataset.doseMin || 0);
        const doseMax = Number(card.dataset.doseMax || 0);
        const durationMin = Number(card.dataset.durationMin || 0);
        const durationMax = Number(card.dataset.durationMax || 0);
        const packUnits = Number(card.dataset.packUnits || 0);
        const referenceDose = Number(card.dataset.referenceDose || 0);

        // Shopify expone el precio del variant en la unidad monetaria mínima (céntimos para EUR).
        // Para el ranking solo importa la comparación relativa, por lo que no convertimos aquí.
        const costPerDayLow = price > 0 && durationMax > 0 ? price / durationMax : null;
        const costPerDayHigh = price > 0 && durationMin > 0 ? price / durationMin : null;
        let costPerDayReference = (
          Number.isFinite(costPerDayLow) &&
          Number.isFinite(costPerDayHigh)
        ) ? (costPerDayLow + costPerDayHigh) / 2 : null;

        // Cuando la matriz define una dosis de referencia y el rango dosis/duración es
        // matemáticamente coherente, el coste de referencia usa esa dosis en vez del
        // promedio entre los extremos. Así, "ahorrar" y "fórmula/precio" comparan la
        // pauta de referencia real sin hardcodear ningún precio.
        if (
          price > 0 &&
          referenceDose > 0 &&
          doseMin > 0 &&
          doseMax > 0 &&
          durationMin > 0 &&
          durationMax > 0 &&
          referenceDose >= doseMin &&
          referenceDose <= doseMax
        ) {
          let referenceDuration = null;

          if (referenceDose === doseMin) {
            referenceDuration = durationMax;
          } else if (referenceDose === doseMax) {
            referenceDuration = durationMin;
          } else {
            const totalAtMinDose = doseMin * durationMax;
            const totalAtMaxDose = doseMax * durationMin;
            const estimatedTotal = (totalAtMinDose + totalAtMaxDose) / 2;
            const rangeDrift = Math.abs(totalAtMinDose - totalAtMaxDose) / Math.max(estimatedTotal, 1);
            if (rangeDrift <= 0.05) referenceDuration = estimatedTotal / referenceDose;
          }

          if (Number.isFinite(referenceDuration) && referenceDuration > 0) {
            costPerDayReference = price / referenceDuration;
          }
        }

        return {
          card,
          role: card.dataset.role || '',
          sku: card.dataset.sku || '',
          matrixOrder: Number(card.dataset.matrixOrder || 0),
          handle: card.dataset.handle || '',
          forms: tokens(card.dataset.form || ''),
          formula: tokens(card.dataset.formula || ''),
          format: card.dataset.format || '',
          toleranceBase: Number(card.dataset.tolerance || 0),
          elementalMg: Number(card.dataset.elementalMg || 0), // metadato; no puntúa en V28
          magnesiumSource: card.dataset.magnesiumSource || '',
          deliveryTechnology: card.dataset.deliveryTechnology || '',
          referenceDose,
          quality: Number(card.dataset.quality || 0),          // metadato; no puntúa en V28
          tier: card.dataset.tier || '',                       // metadato; no puntúa en V28
          price,
          doseMin,
          doseMax,
          durationMin,
          durationMax,
          packUnits,
          costPerDayLow,
          costPerDayHigh,
          costPerDayReference,
          goalAffinity: parseAffinity(card.dataset.goalAffinity || '')
        };
      };

      // La disponibilidad real de Shopify es el único filtro excluyente.
      // Forma, fórmula, formato, tolerancia y precio solo cambian el ranking.
      const isAvailableCandidate = (card) => card.dataset.available === 'true';

      const objectiveScore = (attrs) => {
        if (!answers.goal) return 0;
        const affinity = Number(attrs.goalAffinity[answers.goal] ?? 0);
        return affinity * SCORING.goalMultiplier;
      };

      const formulaPreferenceMatches = (attrs) => {
        if (!answers.priority || answers.priority === 'unsure') return true;
        return (
          (answers.priority === 'simple' && attrs.formula.includes('simple')) ||
          (answers.priority === 'multi' && attrs.formula.includes('multi')) ||
          (answers.priority === 'cofactors' && attrs.formula.includes('cofactors'))
        );
      };

      const formulaScore = (attrs) => {
        if (!answers.priority || answers.priority === 'unsure') return 0;
        return formulaPreferenceMatches(attrs) ? SCORING.formulaMatch : SCORING.formulaMismatch;
      };

      const formatPreferenceMatches = (attrs) => {
        if (!answers.format || answers.format === 'any') return true;
        return attrs.format === answers.format;
      };

      const formatScore = (attrs) => {
        if (!answers.format || answers.format === 'any') return 0;
        return formatPreferenceMatches(attrs) ? SCORING.formatMatch : SCORING.formatMismatch;
      };

      const toleranceAdjustmentFor = (attrs) => {
        const base = Number.isFinite(attrs.toleranceBase) ? attrs.toleranceBase : 0;
        return clamp(
          base * SCORING.toleranceMultiplier,
          SCORING.toleranceMin,
          SCORING.toleranceMax
        );
      };

      const coreBreakdown = (attrs) => {
        const goal = objectiveScore(attrs);
        const formula = formulaScore(attrs);
        const format = formatScore(attrs);
        return {
          goal,
          formula,
          format,
          total: goal + formula + format
        };
      };

      const normalizedCheapness = (value, minValue, maxValue) => {
        if (!Number.isFinite(value) || value <= 0) return 0;
        if (!Number.isFinite(minValue) || !Number.isFinite(maxValue) || maxValue <= minValue) return 0;
        return clamp(1 - ((value - minValue) / (maxValue - minValue)), 0, 1);
      };

      const economicRange = (candidates, coreBand, bestCore) => {
        const eligible = candidates.filter((candidate) => (
          candidate.core.total >= bestCore - coreBand &&
          Number.isFinite(candidate.attrs.costPerDayReference) &&
          candidate.attrs.costPerDayReference > 0
        ));
        const values = eligible.map((candidate) => candidate.attrs.costPerDayReference);
        return {
          eligible,
          min: values.length ? Math.min(...values) : null,
          max: values.length ? Math.max(...values) : null
        };
      };

      const finalPriorityAdjustment = (candidate, context) => {
        switch (answers.purchase) {
          case 'tolerance':
            return candidate.toleranceAdjustment;

          case 'economy': {
            if (candidate.core.total < context.bestCore - SCORING.economyCoreBand) return 0;
            const cheapness = normalizedCheapness(
              candidate.attrs.costPerDayReference,
              context.economyRange.min,
              context.economyRange.max
            );
            return cheapness * SCORING.economyMaxAdjustment;
          }

          case 'value': {
            if (candidate.core.total < context.bestCore - SCORING.valueCoreBand) return 0;
            const cheapness = normalizedCheapness(
              candidate.attrs.costPerDayReference,
              context.valueRange.min,
              context.valueRange.max
            );
            return cheapness * SCORING.valueMaxAdjustment;
          }

          case 'best_fit':
          case 'any':
          default:
            return 0;
        }
      };

      const compareCandidates = (a, b) => {
        // Solo se aplican desempates cuando el finalScore es exactamente igual.
        if (b.score !== a.score) return b.score - a.score;

        // 1) Objetivo principal.
        if (b.core.goal !== a.core.goal) return b.core.goal - a.core.goal;

        // 2) Tolerancia, solo cuando el usuario la ha priorizado.
        if (answers.purchase === 'tolerance' && b.toleranceAdjustment !== a.toleranceAdjustment) {
          return b.toleranceAdjustment - a.toleranceAdjustment;
        }

        // 3) Coincidencia con tipo de fórmula.
        if (b.core.formula !== a.core.formula) return b.core.formula - a.core.formula;

        // 4) Coincidencia con formato.
        if (b.core.format !== a.core.format) return b.core.format - a.core.format;

        // 5) Si precio/valor es la prioridad, menor coste diario de referencia.
        if (answers.purchase === 'economy' || answers.purchase === 'value') {
          const aCost = a.attrs.costPerDayReference;
          const bCost = b.attrs.costPerDayReference;
          if (
            Number.isFinite(aCost) && aCost > 0 &&
            Number.isFinite(bCost) && bCost > 0 &&
            aCost !== bCost
          ) {
            return aCost - bCost;
          }
        }

        // 6) Mayor duración mínima garantizada dentro del rango de uso.
        if (b.attrs.durationMin !== a.attrs.durationMin) return b.attrs.durationMin - a.attrs.durationMin;

        // 7) Orden estable y determinista de la matriz.
        if (a.attrs.matrixOrder !== b.attrs.matrixOrder) return a.attrs.matrixOrder - b.attrs.matrixOrder;
        return a.attrs.sku.localeCompare(b.attrs.sku) || a.attrs.handle.localeCompare(b.attrs.handle);
      };

      const availableCandidates = () => {
        const seen = new Set();
        const candidates = sourceCards
          .filter(isAvailableCandidate)
          .filter((card) => {
            const handle = card.dataset.handle || '';
            if (!handle || seen.has(handle)) return false;
            seen.add(handle);
            return true;
          })
          .map((card) => {
            const attrs = productAttributes(card);
            const core = coreBreakdown(attrs);
            const toleranceAdjustment = toleranceAdjustmentFor(attrs);
            return {
              card,
              attrs,
              core,
              toleranceAdjustment
            };
          });

        if (!candidates.length) return [];

        const bestCore = Math.max(...candidates.map((item) => item.core.total));
        const context = {
          bestCore,
          economyRange: economicRange(candidates, SCORING.economyCoreBand, bestCore),
          valueRange: economicRange(candidates, SCORING.valueCoreBand, bestCore)
        };

        return candidates
          .map((item) => {
            const priorityAdjustment = finalPriorityAdjustment(item, context);
            const finalScore = item.core.total + priorityAdjustment;
            return {
              ...item,
              purchase: priorityAdjustment,
              score: finalScore,
              audit: {
                objectiveScore: item.core.goal,
                formulaScore: item.core.formula,
                formatScore: item.core.format,
                coreScore: item.core.total,
                toleranceAdjustment: item.toleranceAdjustment,
                costPerDayLow: item.attrs.costPerDayLow,
                costPerDayHigh: item.attrs.costPerDayHigh,
                costPerDayReference: item.attrs.costPerDayReference,
                finalPriorityAdjustment: priorityAdjustment,
                finalScore
              }
            };
          })
          .sort(compareCandidates);
      };

      const chooseResults = () => availableCandidates().slice(0, 2);

      const selectedLabel = (questionKey) => {
        return getQuestion(questionKey)?.querySelector('.mq-option.is-selected span:last-child')?.textContent?.trim() || '';
      };

      const lowerFirst = (value = '') => {
        const text = String(value || '').trim();
        if (!text) return '';
        return text.charAt(0).toLocaleLowerCase(root.dataset.language || 'es') + text.slice(1);
      };

      const REASON_COPY = {
        es: {
          goal: (label) => `Buen encaje con ${lowerFirst(label)}`,
          formula: Object.freeze({
            simple: 'Fórmula sencilla, como prefieres',
            multi: 'Combina varias formas de magnesio, como prefieres',
            cofactors: 'Incluye otros nutrientes o cofactores, como prefieres'
          }),
          format: (label) => `${label}, como prefieres`,
          tolerance: () => 'Buena tolerancia digestiva',
          economy: () => 'Entre las opciones que mejor encajan contigo, es de las más económicas',
          value: () => 'Buen equilibrio entre fórmula y precio',
          best_fit: () => 'Muy buen encaje con el conjunto de tus respuestas',
          alt_cheaper: () => 'Una alternativa más económica',
          alt_formula: () => 'Puede interesarte si prefieres esta fórmula',
          alt_format: () => 'Respeta tu preferencia de formato'
        },
        en: {
          goal: (label) => `Good match for ${lowerFirst(label)}`,
          formula: Object.freeze({
            simple: 'A simple formula, as you prefer',
            multi: 'Combines several forms of magnesium, as you prefer',
            cofactors: 'Includes other nutrients or cofactors, as you prefer'
          }),
          format: (label) => `${label}, as you prefer`,
          tolerance: () => 'Good digestive tolerance',
          economy: () => 'Among the options that fit you best, it is one of the more affordable',
          value: () => 'Good balance between formula and price',
          best_fit: () => 'Very good overall match for your answers',
          alt_cheaper: () => 'A more affordable alternative',
          alt_formula: () => 'Worth considering if you prefer this formula',
          alt_format: () => 'Matches your preferred format'
        },
        de: {
          goal: (label) => `Gute Übereinstimmung mit ${lowerFirst(label)}`,
          formula: Object.freeze({
            simple: 'Eine einfache Formel, wie von dir bevorzugt',
            multi: 'Kombiniert mehrere Magnesiumformen, wie von dir bevorzugt',
            cofactors: 'Enthält weitere Nährstoffe oder Cofaktoren, wie von dir bevorzugt'
          }),
          format: (label) => `${label}, wie von dir bevorzugt`,
          tolerance: () => 'Gute Magen-Darm-Verträglichkeit',
          economy: () => 'Unter den passenden Optionen gehört sie zu den günstigeren',
          value: () => 'Gutes Verhältnis zwischen Zusammensetzung und Preis',
          best_fit: () => 'Sehr gute Gesamtübereinstimmung mit deinen Antworten',
          alt_cheaper: () => 'Eine günstigere Alternative',
          alt_formula: () => 'Interessant, wenn du diese Formel bevorzugst',
          alt_format: () => 'Entspricht deiner bevorzugten Darreichungsform'
        },
        pt: {
          goal: (label) => `Bom encaixe com ${lowerFirst(label)}`,
          formula: Object.freeze({
            simple: 'Fórmula simples, como preferes',
            multi: 'Combina várias formas de magnésio, como preferes',
            cofactors: 'Inclui outros nutrientes ou cofatores, como preferes'
          }),
          format: (label) => `${label}, como preferes`,
          tolerance: () => 'Boa tolerância digestiva',
          economy: () => 'Entre as opções que melhor encaixam contigo, é das mais económicas',
          value: () => 'Bom equilíbrio entre fórmula e preço',
          best_fit: () => 'Muito bom encaixe com o conjunto das tuas respostas',
          alt_cheaper: () => 'Uma alternativa mais económica',
          alt_formula: () => 'Pode interessar-te se preferires esta fórmula',
          alt_format: () => 'Respeita a tua preferência de formato'
        }
      };

      // Tradeoffs: lógica V28 separada del copy de razones
      // para que el rediseño de resultados no altere el scoring ni la detección de compromisos.
      const TRADEOFF_COPY = {
        es: {
          tolerance: () => 'Has priorizado la tolerancia digestiva, pero esta opción encaja mejor con lo que buscas en conjunto. Por eso la recomendamos aunque haya alternativas más suaves a nivel digestivo.',
          format: (label) => `Has indicado que prefieres ${label}, pero esta opción encaja mejor con lo que buscas en conjunto. Por eso te recomendamos este otro formato.`,
          formula: (label) => `Has indicado que prefieres «${label}», pero esta opción encaja mejor con lo que buscas en conjunto.`,
          price: () => 'Has indicado que quieres ahorrar, pero esta opción encaja claramente mejor con lo que buscas que las alternativas más económicas.'
        },
        en: {
          tolerance: () => 'You prioritized digestive tolerance, but this option is a better match for what you are looking for overall. That is why we recommend it even though there are gentler options for digestion.',
          format: (label) => `You said you prefer ${label}, but this option is a better match for what you are looking for overall. That is why we recommend this different format.`,
          formula: (label) => `You said you prefer “${label}”, but this option is a better match for what you are looking for overall.`,
          price: () => 'You said you want to save as much as possible, but this option is a clearly better match for what you are looking for than the lower-cost alternatives.'
        },
        de: {
          tolerance: () => 'Du hast eine gute Magen-Darm-Verträglichkeit priorisiert. Insgesamt passt diese Option jedoch besser zu dem, was du suchst. Deshalb empfehlen wir sie, auch wenn es magen-darm-freundlichere Alternativen gibt.',
          format: (label) => `Du hast angegeben, dass du ${label} bevorzugst. Insgesamt passt diese Option jedoch besser zu dem, was du suchst. Deshalb empfehlen wir dir diese andere Darreichungsform.`,
          formula: (label) => `Du hast angegeben, dass du „${label}“ bevorzugst. Insgesamt passt diese Option jedoch besser zu dem, was du suchst.`,
          price: () => 'Du möchtest möglichst günstig kaufen. Diese Option passt jedoch deutlich besser zu dem, was du suchst, als die günstigeren Alternativen.'
        },
        pt: {
          tolerance: () => 'Deste prioridade à tolerância digestiva, mas esta opção encaixa melhor no que procuras no conjunto. Por isso a recomendamos, mesmo existindo alternativas mais suaves a nível digestivo.',
          format: (label) => `Indicaste que preferes ${label}, mas esta opção encaixa melhor no que procuras no conjunto. Por isso recomendamos este outro formato.`,
          formula: (label) => `Indicaste que preferes «${label}», mas esta opção encaixa melhor no que procuras no conjunto.`,
          price: () => 'Indicaste que queres poupar o máximo possível, mas esta opção encaixa claramente melhor no que procuras do que as alternativas mais económicas.'
        }
      };

      const reliableEconomicMetric = (attrs) => {
        if (Number.isFinite(attrs.costPerDayReference) && attrs.costPerDayReference > 0) {
          return attrs.costPerDayReference;
        }
        return null;
      };

      const collectTradeoffs = (winner, ranked) => {
        if (!winner) return [];

        const language = TRADEOFF_COPY[root.dataset.language] ? root.dataset.language : 'es';
        const copy = TRADEOFF_COPY[language];
        const tradeoffs = [];

        // 1) Tolerancia: solo si se seleccionó expresamente y existe una alternativa
        // claramente más tolerable con una adecuación principal razonablemente próxima.
        if (answers.purchase === 'tolerance') {
          const betterTolerance = ranked.find((candidate) => {
            if (candidate === winner) return false;
            const toleranceGain = candidate.toleranceAdjustment - winner.toleranceAdjustment;
            const coreLoss = winner.core.total - candidate.core.total;
            return toleranceGain >= SCORING.tradeoff.toleranceGap && coreLoss <= SCORING.tradeoff.toleranceCoreWindow;
          });
          if (betterTolerance) {
            tradeoffs.push({ type: 'tolerance_tradeoff', text: copy.tolerance() });
          }
        }

        // 2) Formato: preferencia explícita conocida, nunca "me da igual".
        if (answers.format && answers.format !== 'any' && winner.attrs.format !== answers.format) {
          const label = selectedLabel('format');
          if (label) tradeoffs.push({ type: 'format_mismatch', text: copy.format(label) });
        }

        // 3) Tipo de fórmula.
        if (answers.priority && answers.priority !== 'unsure' && !formulaPreferenceMatches(winner.attrs)) {
          const label = selectedLabel('priority');
          if (label) tradeoffs.push({ type: 'formula_type_mismatch', text: copy.formula(label) });
        }

        // 4) Precio: solo cuando existe una comparación fiable por coste/día y una
        // alternativa razonablemente próxima es al menos un 15 % más económica.
        if (answers.purchase === 'economy') {
          const winnerMetric = reliableEconomicMetric(winner.attrs);
          if (Number.isFinite(winnerMetric) && winnerMetric > 0) {
            const cheaperComparable = ranked.find((candidate) => {
              if (candidate === winner) return false;
              const metric = reliableEconomicMetric(candidate.attrs);
              if (!Number.isFinite(metric) || metric <= 0 || metric >= winnerMetric) return false;
              const relativeSaving = (winnerMetric - metric) / winnerMetric;
              const coreLoss = winner.core.total - candidate.core.total;
              return relativeSaving >= SCORING.tradeoff.priceRelativeGap && coreLoss <= SCORING.tradeoff.priceCoreWindow;
            });
            if (cheaperComparable) {
              tradeoffs.push({ type: 'price_tradeoff', text: copy.price() });
            }
          }
        }

        return tradeoffs;
      };

      const buildReasonItems = (candidate, limit = 3) => {
        const language = REASON_COPY[root.dataset.language] ? root.dataset.language : 'es';
        const copy = REASON_COPY[language];
        const reasons = [];
        const goalLabel = selectedLabel('goal');

        if (candidate.core.goal >= 24 && goalLabel) {
          reasons.push(copy.goal(goalLabel));
        }


        if (answers.purchase === 'tolerance' && candidate.toleranceAdjustment > 0) {
          reasons.push(copy.tolerance());
        }

        if (
          candidate.core.formula > 0 &&
          answers.priority &&
          answers.priority !== 'unsure'
        ) {
          const formulaReason = copy.formula?.[answers.priority];
          if (formulaReason) reasons.push(formulaReason);
        }

        if (candidate.core.format > 0) {
          const formatLabel = selectedLabel('format');
          if (formatLabel) reasons.push(copy.format(formatLabel));
        }

        if (candidate.purchase > 0) {
          if (answers.purchase === 'economy') reasons.push(copy.economy());
          else if (answers.purchase === 'value') reasons.push(copy.value());
        }

        if (!reasons.length) reasons.push(copy.best_fit());
        return Array.from(new Set(reasons)).slice(0, limit);
      };

      const buildAlternativeReasonItems = (candidate, primary) => {
        const language = REASON_COPY[root.dataset.language] ? root.dataset.language : 'es';
        const copy = REASON_COPY[language];
        const reasons = [];
        const candidateCost = candidate?.attrs?.costPerDayReference;
        const primaryCost = primary?.attrs?.costPerDayReference;

        if (
          Number.isFinite(candidateCost) &&
          Number.isFinite(primaryCost) &&
          candidateCost > 0 &&
          primaryCost > 0 &&
          candidateCost <= primaryCost * 0.95
        ) {
          reasons.push(copy.alt_cheaper());
        }

        if (
          answers.priority &&
          answers.priority !== 'unsure' &&
          formulaPreferenceMatches(candidate.attrs) &&
          primary &&
          !formulaPreferenceMatches(primary.attrs)
        ) {
          reasons.push(copy.alt_formula());
        }

        if (
          answers.format &&
          answers.format !== 'any' &&
          formatPreferenceMatches(candidate.attrs) &&
          primary &&
          !formatPreferenceMatches(primary.attrs)
        ) {
          reasons.push(copy.alt_format());
        }

        buildReasonItems(candidate, 2).forEach((reason) => reasons.push(reason));
        return Array.from(new Set(reasons)).slice(0, 2);
      };

      const renderReasonList = (container, reasons, isPrimary) => {
        if (!container) return;
        container.textContent = '';

        if (isPrimary) {
          const title = document.createElement('p');
          title.className = 'mq-reason-title';
          title.textContent = root.dataset.i18nReasonTitle || '';
          container.appendChild(title);
        }

        const list = document.createElement('ul');
        list.className = 'mq-reason-list';
        reasons.forEach((reason) => {
          const item = document.createElement('li');
          item.textContent = reason;
          list.appendChild(item);
        });
        container.appendChild(list);
      };

      const labelFor = (index) => {
        if (index === 0) return root.dataset.i18nBest;
        return root.dataset.i18nAlternative;
      };

      const productAnalytics = (candidate) => {
        if (!candidate) return null;
        const card = candidate.card;
        return {
          product_id: card.dataset.productId || null,
          variant_id: card.dataset.variantId || null,
          product_handle: card.dataset.handle || null,
          product_title: card.dataset.productTitle || null,
          product_sku: card.dataset.sku || null,
          score: roundScore(candidate.score)
        };
      };

      const finalAnswerProperties = () => ({
        main_goal: analyticsAnswerKey('goal', answers.goal),
        formula_preference: analyticsAnswerKey('priority', answers.priority),
        requested_magnesium_form: null,
        preferred_format: analyticsAnswerKey('format', answers.format),
        final_priority: analyticsAnswerKey('purchase', answers.purchase)
      });

      const trackCompletedOnce = () => {
        if (completedTracked || !currentResultContext?.top?.length) return;

        trackStartedOnce();

        const first = productAnalytics(currentResultContext.top[0]);
        const second = productAnalytics(currentResultContext.top[1]);
        const third = productAnalytics(currentResultContext.top[2]);
        const tradeoffs = currentResultContext.tradeoffs || [];

        const captured = trackQuizEvent('magnesium_quiz_completed', {
          ...finalAnswerProperties(),

          recommended_product_id: first?.product_id || null,
          recommended_variant_id: first?.variant_id || null,
          recommended_product_handle: first?.product_handle || null,
          recommended_product_title: first?.product_title || null,
          recommended_score: first?.score ?? null,

          second_product_id: second?.product_id || null,
          second_variant_id: second?.variant_id || null,
          second_product_handle: second?.product_handle || null,
          second_product_title: second?.product_title || null,
          second_score: second?.score ?? null,

          third_product_id: third?.product_id || null,
          third_variant_id: third?.variant_id || null,
          third_product_handle: third?.product_handle || null,
          third_product_title: third?.product_title || null,
          third_score: third?.score ?? null,

          has_tradeoff: tradeoffs.length > 0,
          main_tradeoff: tradeoffs[0]?.type || null,
          tradeoff_count: tradeoffs.length,
          tradeoffs: tradeoffs.map((tradeoff) => tradeoff.type)
        });

        if (captured) completedTracked = true;
      };

      const trackResultViewedOnce = () => {
        if (resultViewedTracked || !currentResultContext?.top?.length) return;

        const primary = productAnalytics(currentResultContext.top[0]);
        const secondary = productAnalytics(currentResultContext.top[1]);
        const tradeoffs = currentResultContext.tradeoffs || [];

        const captured = trackQuizEvent('magnesium_quiz_result_viewed', {
          main_goal: analyticsAnswerKey('goal', answers.goal),
          primary_product_title: primary?.product_title || null,
          primary_product_sku: primary?.product_sku || null,
          secondary_product_title: secondary?.product_title || null,
          secondary_product_sku: secondary?.product_sku || null,
          has_tradeoff: tradeoffs.length > 0,
          main_tradeoff: tradeoffs[0]?.type || null
        });

        if (captured) resultViewedTracked = true;
      };

      const setQuizLineProperties = (form, rank) => {
        if (!form) return;
        const values = {
          quiz_id: currentQuizId || '',
          quiz_source: QUIZ_SOURCE,
          quiz_rank: String(rank || ''),
          quiz_version: QUIZ_VERSION
        };

        Object.entries(values).forEach(([key, value]) => {
          const input = form.querySelector(`[data-quiz-line-property="${key}"]`);
          if (input) input.value = value;
        });
      };

      const showResults = () => {
        const ranked = availableCandidates();
        const selected = ranked.slice(0, 2);
        const analyticsTop = ranked.slice(0, 3);
        const primaryTradeoffs = collectTradeoffs(selected[0], ranked);
        const primaryTradeoff = primaryTradeoffs[0] || null;

        currentResultContext = { ranked, top: analyticsTop, tradeoffs: primaryTradeoffs };
        panel.hidden = true;
        intro.hidden = true;
        results.hidden = false;

        primaryResult.innerHTML = '';
        alternativeResult.innerHTML = '';
        alternativeSection.hidden = true;
        volumeOffer.hidden = true;

        const goalButton = getQuestion('goal')?.querySelector('.mq-option.is-selected span:last-child');
        const goalLabel = goalButton?.textContent?.trim();

        resultSummary.textContent = goalLabel
          ? `${root.dataset.i18nSummaryPrefix} ${goalLabel}.`
          : '';

        if (!selected.length) {
          const empty = document.createElement('div');
          empty.className = 'mq-empty';
          empty.textContent = root.dataset.i18nEmpty;
          primaryResult.appendChild(empty);
          return;
        }

        selected.forEach((item, index) => {
          const clone = item.card.cloneNode(true);
          clone.hidden = false;
          clone.removeAttribute('aria-hidden');
          clone.classList.remove('mq-product-card--source');
          clone.classList.toggle('is-primary', index === 0);
          clone.removeAttribute('data-quiz-product');
          clone.dataset.recommendationRank = String(index + 1);
          clone.dataset.isPrimaryRecommendation = index === 0 ? 'true' : 'false';

          const resultForm = clone.querySelector('[data-quiz-product-form]');
          setQuizLineProperties(resultForm, index + 1);

          const badge = clone.querySelector('[data-result-badge]');
          if (badge) badge.textContent = labelFor(index);

          const reason = clone.querySelector('.mq-product-card__reason');
          const reasons = index === 0
            ? buildReasonItems(item, 3)
            : buildAlternativeReasonItems(item, selected[0]);
          renderReasonList(reason, reasons, index === 0);

          const tradeoff = clone.querySelector('[data-tradeoff]');
          if (tradeoff) {
            if (index === 0 && primaryTradeoff?.text) {
              tradeoff.textContent = primaryTradeoff.text;
              tradeoff.hidden = false;
            } else {
              tradeoff.textContent = '';
              tradeoff.hidden = true;
            }
          }

          const addLabel = clone.querySelector('[data-quiz-add-label]');
          if (addLabel && index === 0) {
            addLabel.textContent = root.dataset.i18nPrimaryAdd || addLabel.textContent;
          }

          const trust = clone.querySelector('[data-result-trust]');
          if (trust) {
            if (index === 0) {
              trust.textContent = root.dataset.i18nTrust || '';
              trust.hidden = false;
            } else {
              trust.textContent = '';
              trust.hidden = true;
            }
          }

          const viewLink = clone.querySelector('.mq-product-card__view');
          if (viewLink) {
            viewLink.textContent = index === 0
              ? (root.dataset.i18nPrimaryView || viewLink.textContent)
              : (root.dataset.i18nAlternativeView || viewLink.textContent);
          }

          if (index === 0) {
            primaryResult.appendChild(clone);
            volumeOffer.hidden = false;
          } else {
            alternativeResult.appendChild(clone);
            alternativeSection.hidden = false;
          }
        });

        results.scrollIntoView({ behavior: 'smooth', block: 'start' });

        window.requestAnimationFrame(() => {
          trackCompletedOnce();
          trackResultViewedOnce();
        });

        pushEvent('bt_quiz_complete', {
          result_1: selected[0]?.card.dataset.handle || '',
          result_count: selected.length
        });
      };

      const nextFrom = (key) => {
        const sequence = flow();
        const index = sequence.indexOf(key);
        return sequence[index + 1];
      };

      startButton?.addEventListener('click', () => {
        beginNewQuizRun();
        showPanel();
        showQuestion('goal');
        trackStartedOnce();
        pushEvent('bt_quiz_start');
      });

      questions.forEach((question) => {
        question.querySelectorAll('.mq-option').forEach((button) => {
          button.setAttribute('aria-pressed', 'false');

          button.addEventListener('click', () => {
            const key = question.dataset.question;
            const value = button.dataset.answer;

            question.querySelectorAll('.mq-option').forEach((option) => {
              const selected = option === button;
              option.classList.toggle('is-selected', selected);
              option.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });

            answers[key] = value;

            trackStartedOnce();
            const activeSequence = flow();
            trackQuizEvent('magnesium_quiz_question_answered', {
              question_key: ANALYTICS_QUESTION_KEYS[key] || key,
              question_number: Math.max(1, activeSequence.indexOf(key) + 1),
              answer_key: analyticsAnswerKey(key, value),
              answer_label: button.querySelector('span:last-child')?.textContent?.trim() || button.textContent?.trim() || null
            });

            window.setTimeout(() => {
              const next = nextFrom(key);
              if (next) showQuestion(next);
              else showResults();
            }, 120);
          });
        });
      });

      backButton?.addEventListener('click', () => {
        const sequence = flow();
        const index = sequence.indexOf(currentQuestion);
        if (index > 0) showQuestion(sequence[index - 1]);
      });

      restartButton?.addEventListener('click', () => {
        Object.keys(answers).forEach((key) => delete answers[key]);
        resetSelections();
        beginNewQuizRun();
        results.hidden = true;
        panel.hidden = false;
        showQuestion('goal');
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        trackStartedOnce();
        pushEvent('bt_quiz_restart');
      });

      const clampQuantity = (value) => {
        const parsed = Number.parseInt(value, 10);
        if (!Number.isFinite(parsed)) return 1;
        return Math.min(99, Math.max(1, parsed));
      };

      const normalizeQuantity = (form) => {
        if (!form) return;
        const input = form.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = String(clampQuantity(input.value));
      };

      // Selector de cantidad: modifica el input nativo name="quantity" del product-form de Impact.
      root.addEventListener('click', (event) => {
        const qtyButton = event.target.closest('[data-qty-change]');
        if (!qtyButton || !root.contains(qtyButton)) return;

        const form = qtyButton.closest('[data-quiz-product-form]');
        const input = form?.querySelector('input[name="quantity"]');
        if (!form || !input) return;

        const delta = Number(qtyButton.dataset.qtyChange || 0);
        input.value = String(clampQuantity(Number(input.value || 1) + delta));
        normalizeQuantity(form);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      root.addEventListener('input', (event) => {
        const input = event.target.closest('[data-quiz-product-form] input[name="quantity"]');
        if (!input || !root.contains(input)) return;
        normalizeQuantity(input.closest('[data-quiz-product-form]'));
      });

      root.addEventListener('change', (event) => {
        const input = event.target.closest('[data-quiz-product-form] input[name="quantity"]');
        if (!input || !root.contains(input)) return;
        normalizeQuantity(input.closest('[data-quiz-product-form]'));
      });

      // Un único listener delegado evita duplicar eventos entre imagen, título y enlace.
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-result-grid] .mq-product-card a');
        if (!link || !root.contains(link)) return;

        const card = link.closest('.mq-product-card');
        if (!card) return;

        trackCompletedOnce();
        trackResultViewedOnce();
        const rank = Number(card.dataset.recommendationRank || 0);
        trackQuizEvent('magnesium_quiz_result_clicked', {
          product_id: card.dataset.productId || null,
          variant_id: card.dataset.variantId || null,
          product_handle: card.dataset.handle || null,
          product_title: card.dataset.productTitle || null,
          product_sku: card.dataset.sku || null,
          recommendation_rank: rank || null,
          is_primary_recommendation: rank === 1,
          main_goal: analyticsAnswerKey('goal', answers.goal),
          source: 'quiz_results',
          action: 'view_product'
        });
      });

      root.addEventListener('click', (event) => {
        const addButton = event.target.closest('[data-result-grid] .mq-add');
        if (!addButton || !root.contains(addButton)) return;

        if (
          addButton.classList.contains('is-quiz-loading') ||
          addButton.classList.contains('is-quiz-added')
        ) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      const setQuizAddButtonState = (button, state = 'idle') => {
        if (!button) return;

        const label = button.querySelector('[data-quiz-add-label]');
        if (!button.dataset.quizDefaultLabel && label) {
          button.dataset.quizDefaultLabel = label.textContent.trim();
        }

        button.classList.toggle('is-quiz-loading', state === 'loading');
        button.classList.toggle('is-quiz-added', state === 'added');

        if (state === 'loading') {
          button.setAttribute('aria-busy', 'true');
          if (label) label.textContent = root.dataset.i18nAdding || button.dataset.quizDefaultLabel || '';
          return;
        }

        button.removeAttribute('aria-busy');
        if (state === 'added') {
          if (label) label.textContent = root.dataset.i18nAdded || button.dataset.quizDefaultLabel || '';
          return;
        }

        if (label && button.dataset.quizDefaultLabel) {
          label.textContent = button.dataset.quizDefaultLabel;
        }
      };

      const openQuizCartDrawer = () => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          drawer.show();
          return;
        }

        const opener = document.querySelector('[aria-controls="cart-drawer"]');
        if (opener && typeof opener.click === 'function') opener.click();
      };

      // El formulario usa el mismo web component `product-form` que el tema Impact.
      // El tema gestiona el Ajax, el contador y los errores; el quiz solo añade feedback visual inmediato.
      root.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-quiz-product-form]');
        if (!form || !root.contains(form)) return;

        const card = form.closest('.mq-product-card');
        const variantInput = form.querySelector('input[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const rank = Number(card?.dataset.recommendationRank || 0);
        const addButton = form.querySelector('.mq-add');

        if (
          root._mqPendingAdd &&
          root._mqPendingAdd.button === addButton
        ) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        if (!currentQuizId) beginNewQuizRun();
        trackStartedOnce();
        trackCompletedOnce();
        trackResultViewedOnce();
        setQuizLineProperties(form, rank);

        const selectedCandidate = currentResultContext?.top?.[Math.max(0, rank - 1)] || null;
        const selectedProduct = productAnalytics(selectedCandidate);
        const primary = productAnalytics(currentResultContext?.top?.[0]);
        const tradeoffs = currentResultContext?.tradeoffs || [];

        if (root._mqPendingAdd?.button && root._mqPendingAdd.button !== addButton) {
          setQuizAddButtonState(root._mqPendingAdd.button, 'idle');
        }
        if (root._mqPendingAdd?.safetyTimer) {
          window.clearTimeout(root._mqPendingAdd.safetyTimer);
        }

        setQuizAddButtonState(addButton, 'loading');

        const pendingAdd = {
          productId: selectedProduct?.product_id || card?.dataset.productId || '',
          variantId: selectedProduct?.variant_id || (variantInput?.value ? String(variantInput.value) : (card?.dataset.variantId || '')),
          handle: selectedProduct?.product_handle || card?.dataset.handle || '',
          title: selectedProduct?.product_title || card?.dataset.productTitle || '',
          sku: selectedProduct?.product_sku || card?.dataset.sku || '',
          rank,
          quantity: Math.max(1, Number(quantityInput?.value || 1) || 1),
          recommendedProductId: primary?.product_id || null,
          recommendedProductTitle: primary?.product_title || null,
          recommendedProductSku: primary?.product_sku || null,
          hasTradeoff: tradeoffs.length > 0,
          mainTradeoff: tradeoffs[0]?.type || null,
          button: addButton,
          safetyTimer: null
        };

        pendingAdd.safetyTimer = window.setTimeout(() => {
          if (root._mqPendingAdd !== pendingAdd) return;
          root._mqPendingAdd = null;
          setQuizAddButtonState(addButton, 'idle');
        }, 12000);

        root._mqPendingAdd = pendingAdd;
      }, true);

      const onVariantAdded = (event) => {
        const pending = root._mqPendingAdd;
        if (!pending) return;

        const addedItems = Array.isArray(event.detail?.items)
          ? event.detail.items
          : [];
        const addedIds = addedItems.map((item) =>
          String(item.variant_id || item.id || '')
        );

        if (
          pending.variantId &&
          addedIds.length &&
          !addedIds.includes(String(pending.variantId))
        ) {
          return;
        }

        root._mqPendingAdd = null;
        if (pending.safetyTimer) window.clearTimeout(pending.safetyTimer);
        setQuizAddButtonState(pending.button, 'added');

        const debugPayload = {
          rank: pending.rank,
          productTitle: pending.title,
          sku: pending.sku,
          variantId: pending.variantId,
          quantity: pending.quantity
        };

        debugQuiz('Shopify add success', debugPayload);

        const captured = trackQuizEvent('magnesium_quiz_add_to_cart', {
          product_id: pending.productId || null,
          variant_id: pending.variantId || null,
          product_handle: pending.handle || null,
          product_title: pending.title || null,
          product_sku: pending.sku || null,
          recommendation_rank: pending.rank || null,
          is_primary_recommendation: pending.rank === 1,
          recommended_product_id: pending.recommendedProductId,
          recommended_product_title: pending.recommendedProductTitle,
          recommended_product_sku: pending.recommendedProductSku,
          main_goal: analyticsAnswerKey('goal', answers.goal),
          has_tradeoff: pending.hasTradeoff,
          main_tradeoff: pending.mainTradeoff,
          source: 'quiz_results',
          quantity: pending.quantity
        });

        if (captured) {
          debugQuiz('PostHog add_to_cart captured', debugPayload);
        }

        pushEvent('bt_quiz_add_to_cart', {
          product_handle: pending.handle
        });

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));

        window.setTimeout(() => {
          openQuizCartDrawer();
        }, 280);

        window.setTimeout(() => {
          setQuizAddButtonState(pending.button, 'idle');
        }, 1400);
      };

      const onCartError = () => {
        const pending = root._mqPendingAdd;
        root._mqPendingAdd = null;
        if (!pending) return;
        if (pending.safetyTimer) window.clearTimeout(pending.safetyTimer);
        setQuizAddButtonState(pending.button, 'idle');
      };

      document.addEventListener('variant:add', onVariantAdded);
      document.addEventListener('cart:error', onCartError);

      root._mqCleanup = () => {
        document.removeEventListener('variant:add', onVariantAdded);
        document.removeEventListener('cart:error', onCartError);
        if (root._mqPendingAdd?.safetyTimer) window.clearTimeout(root._mqPendingAdd.safetyTimer);
      };
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-magnesium-quiz]').forEach(initQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-magnesium-quiz]').forEach((root) => {
        if (typeof root._mqCleanup === 'function') root._mqCleanup();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
